// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__wAK_-","title":"Info_title__FuJsV","selects":"Info_selects__XLAW0","requiredAsterisk":"Info_requiredAsterisk__kBU_f"};